var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoudou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44641 7.53768C11.3303 7.53768 12.8575 6.02476 12.8575 4.15849C12.8575 2.29221 11.3303 0.779297 9.44641 0.779297C7.56252 0.779297 6.03533 2.29221 6.03533 4.15849C6.03533 6.02476 7.56252 7.53768 9.44641 7.53768Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5788 23.6452C16.3671 22.6765 17.5875 21.1596 18.4365 19.9731C18.9671 19.2297 19.475 18.306 19.3613 17.7428L17.5345 11.5251H19.4068L22.6056 15.3023C23.2196 16.0232 24.3111 16.1734 25.0995 15.6102C25.9257 15.0169 26.1076 13.8755 25.5088 13.057L21.9916 8.24355C21.6429 7.77798 21.082 7.46259 20.4528 7.45508L13.805 7.42504C12.2283 7.42504 10.9624 7.7855 9.35545 9.92565L6.70239 13.3874L1.69947 13.7103C0.895974 13.7629 0.236498 14.3937 0.183437 15.2122C0.122796 16.0983 0.805012 16.8642 1.69947 16.9243L7.75603 17.3148C8.19568 17.3448 8.65049 17.1947 8.9916 16.8718L11.3111 14.6866L13.0546 18.2985L3.19277 32.0781C2.59393 32.9192 2.73038 34.0981 3.54903 34.774C4.40559 35.4798 5.67906 35.3672 6.3916 34.5186L15.5788 23.6527V23.6452Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8808 24.5763H21.7415L20.0208 20.0107L19.9753 19.8605C19.8237 20.1383 19.6417 20.4162 19.4447 20.694C18.4517 22.0832 17.019 23.8554 16.2534 24.7791L18.0423 27.7678L18.2546 28.1207C18.6563 28.789 19.4295 29.202 20.2633 29.1194L27.0779 28.4211C28.0557 28.3159 28.8213 27.4974 28.8213 26.5062C28.8213 25.4399 27.9496 24.5763 26.8808 24.5763Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoudou);
export default __webpack_public_path__ + "static/media/koudou.783b502b9289342ac7ad0655598dfedf.svg";
export { ForwardRef as ReactComponent };